import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import actions from "../../context/actions/actions";
import actionsUser from "../../context/users/actions";
import settingActions from "../../context/settings/actions";
import { notify } from "../../libraries/notifications";
import ActionCard from "../../components/customs/ActionCard";
import Button from "../../components/commons/Button";
import { history } from "../../routes";
import Loader from "../../components/commons/Loader";
import config from "../../config/";
import { RepoructorVideo } from "../onboarding/RepoructorVideo";
import ButtonIcon from "../../components/commons/ButtonIcon";

class FlowStep1 extends Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.idFlow = this.props.match.params.id;
    this.currentUrl = this.props.location?.pathname;
    this.state = {
      action: null,
      flow: null,
      isOpenModal:false,
      so:'Android',
      appMode:this.props?.mode_app_settings?.item?.value||"normal",
      // Config del onboarding por empresa (settings). Default false = botones ocultos
      // (opt-in: si la empresa no los tiene seteados, no se muestran).
      showSkip: false,
      showNeverAgain: false,
      dismissing: false,
    };
  }

  openModal  =()=>  this.setState({isOpenModal:true})
  closeModal =()=> this.setState({isOpenModal:false})

  // Lee un setting booleano por code; default false si no existe para esta empresa.
  // Tolerante a las distintas representaciones de "on" que puede guardar el panel
  // (string "true"/"1", boolean true, number 1). Cualquier otra cosa => false (opt-in).
  readFlag = (settingsList, code) => {
    const setting = (settingsList || []).find((s) => s.code === code);
    if (!setting) return false;
    const v = setting.value;
    return v === true || v === 1 || v === "true" || v === "1";
  }

  // Carga los settings de onboarding de la empresa del usuario y deriva los flags.
  async getOnboardingConfig() {
    const owner = this.props.auth?.user?.unique_id;
    if (!owner) return;
    await this.props.onGetSetting({ owner });
    const { settings } = this.props;
    if (settings?.error) return;
    const items = settings?.items || [];
    this.setState({
      showSkip: this.readFlag(items, "show_onboarding_skip"),
      showNeverAgain: this.readFlag(items, "show_onboarding_never_again"),
    });
  }

  // "Omitir": entra a la app sin tocar `tour` (el onboarding reaparece en próximos
  // ingresos). El flag de sesión evita que Home.validarFlujo rebote de inmediato al flow.
  onSkip = () => {
    try { sessionStorage.setItem(config.ONBOARDING_SKIPPED, '1'); } catch (e) {}
    history.push(config.ROUTES.HOME);
  }

  // "No mostrar nunca más": marca todas las posiciones del `tour` con fecha (mismo
  // formato que completar un flow) para que validarFlujo vea indexOf('0') < 0 y no
  // vuelva a mostrar el onboarding. Como se hace acá (no en FlowStep3), NO otorga premio.
  onNeverAgain = async () => {
    if (this.state.dismissing) return;
    this.setState({ dismissing: true });
    const user = this.props.auth?.user;
    if (!user?.id) {
      this.setState({ dismissing: false });
      return history.push(config.ROUTES.HOME);
    }
    const appmode = this.state.appMode || "normal";
    const arraysFlows = config.FLOWS[appmode] ?? config.FLOWS["normal"];
    const tour = Array(arraysFlows.length).fill(0).map(() => new Date()).join(",");
    await this.props.onSaveOrUpdatedUser({ id: user.id, tour });
    if (this.props.userUpdate?.error) {
      notify(this.props.userUpdate.error);
      this.setState({ dismissing: false });
      return;
    }
    await this.props.onGetToken();
    history.push(config.ROUTES.HOME);
  }

  async getFlow() {
    const modeApp = this.state.appMode || "normal"
    const flowsApp = config.FLOWS[modeApp] ?? config.FLOWS["normal"]
    const flow = await flowsApp?.find((f) => f.id == this.idFlow);
    if (flow) {
      // alert(JSON.stringify(flow?.action.id))
      await this.getAction({ id: flow?.action.id })
      this.setState({ flow: flow });
    }
  }

  async getAction(id) {
    await this.props.onGetAction(id)
    const error = this.props.action.error
    if (error) {
      notify(error)
    } else {
      this.setState({ action: this.props.action.item })
    }
    // this.setState({ action: this.state.flow?.action });
  }

  componentDidMount() {
   this.getFlow();
   this.getOnboardingConfig();
    const userAgent = window.navigator.userAgent;
    let op = 'Android';
 if (/Android/.test(userAgent)) {
      op = 'Android';
    } else if (/iPhone|iPad|iPod/.test(userAgent)) {
      op = 'iOS';
    }
    this.setState({so:op}) 
  }

  componentDidUpdate(prevProps, prevState) {
    if ((prevProps?.mode_app_settings?.item?.value !== this.props?.mode_app_settings?.item?.value && this.state.appMode !== this.props.mode_app_settings?.value)) {
      this.setState({ appMode: this.props.mode_app_settings?.item?.value })
    }
    if(prevState.appMode !== this.state.appMode){
      this.getFlow();
    }
  }

  render() {
    const arrPasos={
      iOS:[
      'Accedé a la web de Sharyco desde el navegador de tu celular <a href="https://app.sharyco.com" aria-label="Sharyco website">https://app.sharyco.com</a>',
      "Iniciá sesión completando tus datos",
      "Presioná el icono central de la barra inferior “para compartir”, desplazá hacia arriba el menú para ver todas las opciones y seleccioná “Agregar al inicio”'",
      "Pulsá el botón “Agregar”",
      "Así aparecerá el icono de la web en tu pantalla de celular"
    ],
    Android:[
      'Accedé a la web de Sharyco desde el navegador de tu celular <a href="https://app.sharyco.com" aria-label="Sharyco website">https://app.sharyco.com</a>',
      "Iniciá sesión completando tus datos",
      "Pulsa el botón de ajustes (los 3 puntitos arriba a la derecha) y luego seleccioná “Agregar a la pantalla”",
      "Pulsá el botón “Agregar”",
      "Y luego el de “Agregar automáticamente”",
      "¡Y listo! Así aparecerá el icono de la web en tu pantalla de celular"
    ]
  }
    return (
      <main className="h-full text-center">
        <Modal isOpen={this.state.isOpenModal} onClose={this.closeModal}>
        {this.state.action&&<RepoructorVideo video={this.state.action.json_data.video}   />}
        <div>
            <h3 className="font-bold text-xl mt-3">¿Cómo se hace?</h3>
            <ul className="flex flex-col gap-1 text-left px-4 py-3">
               {
                arrPasos[this.state.so].map((p,i)=>(
                  <li key={p} className="flex gap-3">
                    <div className="text-sm rounded-full bg-base-200 h-[20px] w-[20px] flex justify-center items-center font-bold p-[11px]">
                      {i+1}

                    </div>
                    <p className="text-base text-gray-500" dangerouslySetInnerHTML={{ __html: p }}></p>
                  </li>
                ))
               }
            </ul>
            <div className="items-center gap-3 flex px-4 py-3">
              <ButtonIcon
                className=""
                icon="arrow_left"
                title={this.t(`${!this.state?.action?.json_data?.sub_type||this.state?.action?.json_data?.sub_type == 'regular' ? 'Hacer acción' : 'Mirar video'}`).toUpperCase()}
                onClick={() => {
                  this.closeModal();
                }
                }
              />
              <Button
                className="flex-1 btn-primary"
                title={this.t(`${this.state.flow?.textButtonStep1?this.state.flow?.textButtonStep1:(!this.state?.action?.json_data?.sub_type||this.state?.action?.json_data?.sub_type == 'regular' )? 'Hacer acción' : 'Mirar video'}`).toUpperCase()}
                onClick={() => {
                  this.closeModal();
                  history.push({ pathname: `/flow/${this.idFlow}/step2`, state: { id: this.state?.action.id, fromPath: this.props.location.pathname } })
                }
                }
              />
          </div>
        </div>
        </Modal>
        {this.props.action.loading && <Loader />}
        {!this.props.action.error && !this.props.action.loading && !this.props.action.item && <p>Ocurrio un error</p>}
        {this.state.action && (
          <CardOnboarding>
              <div className="px-8 pt-20">
                <h1 className="text-primary text-2xl mb-5">
                  {this.t(this.state.flow?.title)}
                </h1>
                <p className="text-primary a base-text-content mt-10 text-lg">
                  {this.t(this.state.flow?.subtile)}
                </p>
              </div>
            <div className="w-full px-8">
              <div className="text-left">
                <ActionCard data={this.state.action} route={""} />
              </div>
              {this.state.action &&
                (this.state.action.json_data.sub_type == 'regular' ||
                  !this.state.action.json_data?.sub_type) &&
                this.state.action.json_data?.video &&
                <button className="text-center mt-6 mx-auto font-bold underline text-xl" onClick={() => this.openModal()}>Ver cómo se hace</button>}
            </div>
            <div className="p-8">
             <Button
              className="btn-block btn-primary"
              title={this.t(`${this.state.flow?.textButtonStep1? this.state.flow?.textButtonStep1:(!this.state?.action?.json_data?.sub_type||this.state?.action?.json_data?.sub_type == 'regular' )? 'Hacer acción' : 'Mirar video'}`).toUpperCase()}
              onClick={() => {
                 history.push({ pathname: `/flow/${this.idFlow}/step2`, state: { id: this.state?.action.id, fromPath: this.props.location.pathname } })
              }
              }
            />
            {this.state.showSkip && (
              <button
                className="btn btn-ghost btn-block mt-2"
                onClick={this.onSkip}
              >
                {this.t("Omitir").toUpperCase()}
              </button>
            )}
            {this.state.showNeverAgain && (
              <button
                className="text-center mt-4 mx-auto block underline text-base text-gray-500"
                disabled={this.state.dismissing}
                onClick={this.onNeverAgain}
              >
                {this.t("No mostrar nunca más")}
              </button>
            )}
            </div>
          </CardOnboarding>
        )}
    
      </main>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    action: state.actions.current,
    mode_app_settings: state.settings.appmode,
    auth: state.users.auth,
    userUpdate: state.users.current,
    settings: state.settings.list,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onGetAction: (params) => dispatch(actions.get(params)),
    onGetSetting: (params) => dispatch(settingActions.getAll(params)),
    onSaveOrUpdatedUser: (params) => dispatch(actionsUser.saveOrUpdate(params)),
    onGetToken: () => dispatch(actionsUser.getFromToken()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(FlowStep1));

export const CardOnboarding = ({ children }) => {
  return (
    <div className="container max-w-md h-full w-full mx-auto flex items-center justify-center">
      <div className="card white h-full w-full md:h-auto justify-between gap-10 rounded-none md:rounded-xl overflow-hidden">
        {children}
      </div>
    </div>
  );
}; 

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto border shadow-lg rounded-md bg-white max-w-[450px]">
          <div className=" ">
            {children}
        </div>
      </div>
    </div>
  );
}; 
